import ContentLoader from 'react-content-loader';

const styles = {
  barRect: {
    clipPath: 'inset(0px 0px 4px 0px)',
  },
};

const StatevectorLoader = () => (
  <ContentLoader
    backgroundColor="rgba(0,96,250, 0.1)"
    foregroundColor="rgba(204,116,245, 0.3)"
    viewBox="0 0 410 180"
    data-test-id="statevectorLoader"
  >
    {/* <rect x="0" y="0" rx="3" ry="3" width="1" height="91" /> */}
    <rect x="0" y="90" rx="3" ry="3" width="405" height="1" />

    <rect x="5" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="20" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="35" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="50" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="65" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="80" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="95" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="110" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="125" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="140" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="155" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="170" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="185" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="200" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="215" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="230" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="245" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="260" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="275" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="290" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="305" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="320" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="335" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="350" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="365" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
    <rect x="380" y="20" rx="5" ry="5" width="4" height="75" style={styles.barRect} />
    <rect x="395" y="10" rx="5" ry="5" width="4" height="85" style={styles.barRect} />
  </ContentLoader>

);

export default StatevectorLoader;
